/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  message, Modal, Form, Spin, Timeline, Tag,
} from 'antd'

import { format } from 'date-fns'

import { fetch } from '../../utils/fetch'

const TimeLineModal = ({ orderId, visible, onCancel }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])

  const statusColor = (orderStatus) => {
    if (orderStatus === undefined) return 'gray'
    if (orderStatus === null) return 'gray'
    if (orderStatus === 'DRF') return 'gray'
    if (orderStatus === 'REJ') return '#F5222D'
    if (orderStatus === 'OBS') return '#FF6E40'
    if (orderStatus === 'ERR') return '#FFC53D'
    if (orderStatus === 'SOC') return '#1E88E5'
    if (orderStatus === 'PRC') return '#669966'
    if (orderStatus === 'ODI') return '#E53935'
    if (orderStatus === 'ODS') return '#7C4DFF'
    if (orderStatus === 'ODV') return '#512DA8'
    if (orderStatus === 'SOA') return '#52C41A'
    if (orderStatus === 'POC') return '#096DD9'
    if (orderStatus === 'POR') return '#CF1322'
    if (orderStatus === 'POA') return '#7CB305'
    if (orderStatus === 'PRD') return '#795548'
  }

  const getOrderStatus = () => {
    fetch({
      url: `/order/${orderId}/status`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        setData(res.data.data)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
    })
    setIsLoading(false)
  }

  useEffect(() => {
    if (visible) {
      getOrderStatus()
    }
  }, [visible])

  return (
    <Modal
      centered
      title={`Timeline Order: ${orderId}`}
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      footer={null}
    >
      <Spin spinning={isLoading} tip="Loading...">
        <Timeline mode="right">
          {data && data.map((item) => (
            <Timeline.Item
              label={(
                <>
                  <div>{item?.createdAt ? format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm') : '-'}</div>
                  <div>{item?.createdBy ? item.createdBy : '-'}</div>
                </>
              )}
              color={statusColor(item?.statusCode)}
            >
              <Tag
                style={{ marginBottom: '1rem' }}
                color={statusColor(item?.statusCode)}
              >{item?.status?.statusDescr ? item.status.statusDescr : '-'}
              </Tag>
            </Timeline.Item>
          ))}
        </Timeline>
      </Spin>
    </Modal>
  )
}

export default TimeLineModal
